import { UserDto } from '../user.dto';
import { ArrayMinSize, IsArray, IsDateString, IsEnum, IsNotEmpty, IsNumber, IsOptional, IsString } from 'class-validator';
import { Transform, Type } from 'class-transformer';

export enum TaskStatusEnum {
  NEW = 1,
  IN_PROGRESS = 2,
  COMPLETED = 3,
  CLOSED = 4,
}

export class TaskDto {
  id: number;

  @IsString()
  @IsNotEmpty()
  theme: string;

  @IsOptional()
  @IsString()
  description?: string | null;

  @IsEnum(TaskStatusEnum)
  status: TaskStatusEnum;

  @IsOptional()
  @IsDateString()
  @Transform(({ value }) => (value ? new Date(value) : value), { toClassOnly: true })
  dueDate?: Date | null;

  @IsOptional()
  @IsDateString()
  @Transform(({ value }) => (value ? new Date(value) : value), { toClassOnly: true })
  createdAt?: Date;

  @IsOptional()
  @IsDateString()
  @Transform(({ value }) => (value ? new Date(value) : value), { toClassOnly: true })
  updatedAt?: Date;

  @IsOptional()
  @IsDateString()
  @Transform(({ value }) => (value ? new Date(value) : value), { toClassOnly: true })
  deletedAt?: Date | null;

  manager?: UserDto | null;
  employees?: UserDto[];
}

export class CreateTaskDto {
  @IsString()
  @IsNotEmpty()
  theme: string;

  @IsOptional()
  @IsString()
  description?: string | null;

  @IsOptional()
  @IsNumber()
  managerId?: number | null;

  @IsArray()
  @IsNumber({}, { each: true })
  @IsNotEmpty()
  employeeIds: number[];   // массив ID сотрудников

  @IsOptional()
  @IsDateString()
  @Transform(({ value }) => (value ? new Date(value) : value))
  dueDate?: Date | null;

  @IsOptional()
  @IsEnum(TaskStatusEnum)
  status?: TaskStatusEnum;
}

export class UpdateTaskDto {
  @IsOptional()
  @IsString()
  theme?: string;

  @IsOptional()
  @IsString()
  description?: string | null;

  @IsOptional()
  @IsNumber()
  managerId?: number | null;

  @IsOptional()
  @IsArray()
  @ArrayMinSize(1)
  @IsNumber({}, { each: true })
  employeeIds?: number[];

  @IsOptional()
  @IsDateString()
  @Transform(({ value }) => (value ? new Date(value) : value))
  dueDate?: Date | null;

  @IsOptional()
  @IsEnum(TaskStatusEnum)
  status?: TaskStatusEnum;
}
